export { default } from './Icon';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Icon/index.js
// module id = 829
// module chunks = 2